import { KeenSliderInstance } from "keen-slider";

export default function useKeenAutoplayPlugin(timeout = 5000) {
    const keenAutoplayPlugin = (slider: KeenSliderInstance) => {
        let timeoutHandler;
        let mouseOver = false;

        function clearNextTimeout() {
            clearTimeout(timeoutHandler);
        }

        function nextTimeout() {
            clearTimeout(timeoutHandler);
            if (mouseOver) return;
            timeoutHandler = setTimeout(() => {
                slider.next();
            }, timeout);
        }

        slider.options.loop = true;
        slider.on("created", () => {
            slider.container.addEventListener("mouseenter", () => {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseleave", () => {
                mouseOver = false;
                nextTimeout();
            });

            nextTimeout();
        });
        
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    };

    return keenAutoplayPlugin;
}
